import { render } from "./edit_blog.vue?vue&type=template&id=5c5b4d3b"
import script from "./edit_blog.vue?vue&type=script&lang=js"
export * from "./edit_blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__